import { useCallback, useMemo } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { useHistory } from '@/modules/core';

import { IAccountType } from '../EmployerDashboard.types';
import { useGetPlansQuery } from '../queries';

interface Params {
  planId: string;
  planYearId: string;
}
const useGetEmployerPlans = ({ planId, planYearId }: Params) => {
  const history = useHistory();

  const { data: plans, isLoading, isError } = useGetPlansQuery();

  const foundPlan = useMemo(() => plans?.find((plan) => plan.id === planId), [planId, plans]);
  const currentPlanType = useMemo(() => foundPlan?.accountType, [foundPlan?.accountType]);
  const isHSA = useMemo(() => currentPlanType === IAccountType.HSA, [currentPlanType]);
  const handleSetCurrentPlan = useCallback(
    (newId: OptionKey) => {
      history.push(ROUTES.ACCOUNT_USAGE_DASHBOARD(newId as string, planYearId));
    },
    [history, planYearId]
  );
  return {
    isHSA,
    setCurrentPlan: handleSetCurrentPlan,
    currentPlan: planId,
    currentPlanType,
    foundPlan,
    isLoading,
    isError,
    plans,
  };
};

export default useGetEmployerPlans;
